import { useCallback, useState } from 'react';

/**
 * Report显示数据流
 */
export default function useReportModel() {
  const [open, setOpen] = useState<boolean>(false);
  const [autoDownload, setAutoDownload] = useState<boolean>(false);

  const previewReport = useCallback((download: boolean = false) => {
    setAutoDownload(download);
    setOpen(true);
  }, []);

  const closePreview = useCallback(() => {
    setOpen(false);
    setAutoDownload(false);
  }, []);

  return {
    previewOpen: open,
    autoDownload,
    previewReport,
    closePreview,
  };
}
